import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "ic-launch_5a62d837a19ebd9897e8f7ee524a4e9c",
  "use": "ic-launch_5a62d837a19ebd9897e8f7ee524a4e9c-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 16 16\" id=\"ic-launch_5a62d837a19ebd9897e8f7ee524a4e9c\">\n    <path fill=\"#4B4B4B\" d=\"M12.667 12.667H3.333V3.333H8V2H3.333C2.593 2 2 2.6 2 3.333v9.334C2 13.4 2.593 14 3.333 14h9.334C13.4 14 14 13.4 14 12.667V8h-1.333v4.667zM9.333 2v1.333h2.394L5.173 9.887l.94.94 6.554-6.554v2.394H14V2H9.333z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id